import { Tabs } from '@treams/treams-ui';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

export default function UserConversationTabs(props: { user?: graphql.User }) {
	const { t } = useTranslation();

	return (
		<Tabs.Container>
			{props.user && (
				<>
					<Tabs.Item
						title={t('user.conversations.tab.incoming.title', {
							name: props.user.firstName,
						})}
						selected
						path={`/users/${props.user.id}/conversations`}
					/>
					<Tabs.Item
						title={t('user.conversations.tab.outgoing.title', {
							name: props.user.firstName,
						})}
						path={`/users/${props.user.id}/conversations/outgoing`}
					/>
				</>
			)}
		</Tabs.Container>
	);
}
